import { Pipe, PipeTransform } from '@angular/core';
import { get, sortBy } from 'lodash';
import { getReferenceDataById } from '../functions/get-reference-data-by-id';
import { IReferenceData } from '../interfaces/form/reference-data.model';

@Pipe({
    name: 'sortByEiDocumentTypePipe',
    standalone: false
})
export class SortByEiDocumentTypePipe implements PipeTransform {
  transform(data: unknown[], eiDocumentTypes: IReferenceData[]): unknown[] {
    return sortBy(data, (d: unknown) => {
      const docTypeId: string = get(d, 'eiDocumentType');

      if (isNaN(+docTypeId)) {
        return 0;
      }

      return getReferenceDataById(+docTypeId, eiDocumentTypes).sortOrder;
    });
  }
}
